import React from 'react';
import { Link } from 'react-router-dom';
import { MessageCircle, ArrowRight } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

const WhatsAppSection = () => {
  const { isDarkMode } = useTheme();

  return (
    <section className="section">
      <div className="container-custom">
        <div className="text-center mb-12">
          <div
            className={`inline-flex items-center justify-center w-16 h-16 rounded-2xl mb-6 ${
              isDarkMode ? 'bg-fsgu-green-500/20' : 'bg-fsgu-green-500/10'
            }`}
          >
            <MessageCircle
              className={`w-8 h-8 ${
                isDarkMode ? 'text-fsgu-green-400' : 'text-fsgu-green-500'
              }`}
            />
          </div>

          <h2
            className={`text-3xl sm:text-4xl font-bold mb-4 font-cursive ${
              isDarkMode ? 'text-fsgu-silver-100' : 'text-fsgu-silver-900'
            }`}
          >
            Join Our WhatsApp Group
          </h2>

          <p
            className={`text-lg max-w-2xl mx-auto ${
              isDarkMode ? 'text-fsgu-silver-400' : 'text-fsgu-silver-600'
            }`}
          >
            Stay connected with tournament updates, results, and community discussions
          </p>
        </div>

        <div className="flex justify-center mb-8">
          <div
            className={`w-full max-w-sm rounded-xl overflow-hidden transition-all duration-300 hover:scale-105 border ${
              isDarkMode
                ? 'bg-fsgu-gray-800 border-fsgu-gray-700'
                : 'bg-fsgu-white border-fsgu-silver-200'
            }`}
          >
            <div className="p-5">
              <div className="text-center mb-4">
                <h3
                  className={`text-base font-bold mb-1 ${
                    isDarkMode ? 'text-fsgu-silver-100' : 'text-fsgu-silver-900'
                  }`}
                >
                  FSGU Info &amp; Communication
                </h3>
                <p
                  className={`text-xs ${
                    isDarkMode ? 'text-fsgu-silver-400' : 'text-fsgu-silver-600'
                  }`}
                >
                  WhatsApp group
                </p>
              </div>

              <div
                className={`rounded-lg p-4 mb-4 ${
                  isDarkMode ? 'bg-fsgu-gray-700' : 'bg-fsgu-silver-50'
                }`}
              >
                <img
                  src="/fsgu-wa.png"
                  alt="FSGU Info and Communication QR Code"
                  className="w-full h-auto max-w-[200px] mx-auto"
                />
              </div>

              <p
                className={`text-xs text-center mb-3 ${
                  isDarkMode ? 'text-fsgu-silver-500' : 'text-fsgu-silver-600'
                }`}
              >
                Scan with WhatsApp to join
              </p>

              <a
                href="https://chat.whatsapp.com/LkO62oc0QouINWZY69Oulb"
                target="_blank"
                rel="noopener noreferrer"
                className={`block text-center py-2 px-4 rounded-lg text-sm font-medium transition-all duration-300 ${
                  isDarkMode
                    ? 'bg-fsgu-green-500/20 hover:bg-fsgu-green-500/30 text-fsgu-green-400'
                    : 'bg-fsgu-green-500/10 hover:bg-fsgu-green-500/20 text-fsgu-green-600'
                }`}
              >
                Open link to join
              </a>
            </div>
          </div>
        </div>

       
      </div>
    </section>
  );
};

export default WhatsAppSection;